<template>
    <div class="card shadow mb-3">
        <div class="card-header py-3">
            <h6 class="m-0 font-weight-bold text-primary">
                <i class="fas fa-info-circle text-muted"
                   style=""
                   data-toggle="tooltip"
                   data-placement="top"
                   :title="$info['timing.month']"></i>
                Zeitraum
            </h6>
        </div>
        <div class="card-body">

            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>Hauptmonat</label>
                        <div class="row">
                            <div class="col">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Monat</span>
                                    </div>
                                    <input type="number" class="form-control" placeholder="01" v-model="config.mainMonth">
                                </div>
                            </div>
                            <div class="col">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Jahr</span>
                                    </div>
                                    <input type="number" class="form-control" placeholder="2022" v-model="config.mainYear">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>&nbsp;</label>
                        <div class="row">
                            <div class="col">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Vormonate</span>
                                    </div>
                                    <input type="number" class="form-control" placeholder="0" v-model="config.minusMonths">
                                </div>
                            </div>
                            <div class="col">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Nachmonate</span>
                                    </div>
                                    <input type="number" class="form-control" placeholder="0" v-model="config.plusMonths">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-check" v-if="compare">
                <input class="form-check-input" type="checkbox" value="" id="timing-compare" v-model="config.comparePeriods">
                <label class="form-check-label" for="timing-compare">
                    Vergleich mit Vorjahr
                </label>
            </div>

        </div>
    </div>
</template>

<script>

export default {
    props: {
        dto: {
            type: Object,
            required: true
        },
        compare: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            config: this.dto
        };
    },
}
</script>
